"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./Counter.scss");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Counter =
/*#__PURE__*/
function (_Component) {
  _inherits(Counter, _Component);

  function Counter() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Counter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Counter)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      count: _this.props.initialCount,
      lastClicked: ''
    };

    _this.minusClicked = function () {
      if (_this.state.count > 0) {
        var newCount = _this.state.count - 1;

        _this.props.onChange(newCount);

        _this.setState({
          count: newCount,
          lastClicked: 'minus'
        });
      }
    };

    _this.plusClicked = function () {
      if (_this.state.count < _this.props.maxCount) {
        var newCount = _this.state.count + 1;

        _this.props.onChange(newCount);

        _this.setState({
          count: newCount,
          lastClicked: 'plus'
        });
      }
    };

    return _this;
  }

  _createClass(Counter, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.initialCount !== this.props.initialCount) {
        this.setState({
          count: nextProps.initialCount
        });
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var className = 'c-Counter';
      return _react2.default.createElement("div", {
        className: "".concat(className, "__container"),
        id: this.props.name
      }, _react2.default.createElement("button", {
        className: "".concat(className, "__minusButton").concat(this.state.lastClicked === 'minus' ? " ".concat(className, "__minusButton--focused") : ''),
        id: "".concat(this.props.name, "__minusButton"),
        onClick: this.minusClicked,
        type: "button",
        onBlur: this.props.onBlur
      }, "-"), _react2.default.createElement("div", {
        className: "".concat(className, "__content")
      }, _react2.default.createElement("label", {
        className: "".concat(className, "__count")
      }, this.state.count)), _react2.default.createElement("button", {
        className: "".concat(className, "__plusButton").concat(this.state.lastClicked === 'plus' ? " ".concat(className, "__plusButton--focused") : ''),
        id: "".concat(this.props.name, "__plusButton"),
        onClick: this.plusClicked,
        type: "button",
        onBlur: this.props.onBlur
      }, "+"));
    }
  }]);

  return Counter;
}(_react.Component);

Counter.defaultProps = {
  initialCount: 1,
  maxCount: 10
};
exports.default = Counter;